export default {
  'SET_TRIGGERS'(state, data) {
    state.triggers = data;
  },
  'ADD_TRIGGER'(state, data) {
    state.triggers.push(data);
  },
  'MODIFY_TRIGGER'(state, data) {
    state.triggers = state.triggers.map(item => {
      if (parseInt(item.id) === parseInt(data.id)) {
        return data;
      }

      return item;
    });
  }
};